import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";
// import GUI_Header from "./gui/GUI_Header";

const EggDropping = () => {
	useEffect(() => {
		document.title =
			"Egg Dropping Puzzle: find the correct response without exceeding a number of certain failure states.";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("2"); //int
	const [guiTxt2, guiTxtChange2] = useState("10");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			egg = parseInt(guiTxt1);
			floor = parseInt(guiTxt2);
			memory = T.getMatrix(egg + 1, floor + 1, 0);
			if (egg == 0 || floor == 0) {
				return;
			}
			//----------------------
			Timer.setTimeBudget(4999);
			Timer.start();
			process();
			txt_time = Timer.stop_print();
			//--------------------------
			BuildResult();
			memory = []; 
		}
	};

	var txt_time = "";
	var memory = []; // int[][]
	var result = 0;
	var egg;
	var floor;

	function process() {
		if(egg < 2){ result = floor; return; }
		result = eggDrop(egg, floor);
		// console.log("answer: " + result);
	}

	function eggDrop(n, k) {
		if (memory[n][k] != 0) {
			return memory[n][k];
		}
		var trial = 0;
		if (k == 0) {
			trial = 0;
		} else if (n == 1) {
			trial = k;
		} else if (n > 1) {
			var trial0 = 9999;
			for (var f0 = 1; f0 <= k; f0++) {
				var trial_new =
					1 + Math.max(eggDrop(n, k - f0), eggDrop(n - 1, f0 - 1)); //egg not break vs egg break
				if (trial_new < trial0) {
					trial0 = trial_new;
				}
			}
			trial = trial0;
		}
		memory[n][k] = trial;
		return trial;
	}

	//-------------------------
	function BuildResult() {
		var txt = `Minimum number of trials in worst case with ${egg} eggs and ${floor} floors is ${result}.`;
		var txt2 = txt_time;//var txt2 = "\n" + txt_time;
		var txtTitle = "Worst Case : Floor Range (" + egg;
		txtTitle += egg > 1 ? " eggs)" : " egg)";
		var maxEgg = memory[memory.length - 1];
		//---------------------
		// var limit = 10000;
		var lastWorst = 1;
		var fromFloor = 1;
		var txt3 = "";
		if (egg > 1) {
			for (var i = 1; i <= maxEgg.length; i++) {
				// if(i > 10000){ txt3 += "\n..."; break; }
				if (maxEgg[i] > lastWorst) {
					txt3 += txt3 != "" ? "\n" : "";
					txt3 += lastWorst + " : Floor ";
					txt3 += fromFloor == i - 1 ? fromFloor : fromFloor + "-" + (i - 1);
					lastWorst = maxEgg[i];
					fromFloor = i;
				}
				if (i == maxEgg.length) {
					txt3 += txt3 != "" ? "\n" : "";
					txt3 += lastWorst + " : Floor ";
					txt3 += fromFloor == i - 1 ? fromFloor : fromFloor + "-" + (i - 1);
				}
			}
		}
		else{ txt3 += "1 : Floor 1-" + floor; }
		//---------------------
		// console.log("CHECK: \n" + T.matrix_print(memory));
		var part1 = Template.simple3size("key1", "Result", txt, txt2, 22, 20, 17);
		var part2 = Template.simple00("key2", 1, txtTitle, txt3, 20, 18);

		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
			</div>
		);
	}

	//--------------------------------------------------------

	return (
		<GUIset_2Input
			// noHeader = {true}
			title={"Egg Dropping Puzzle"}
			// desc={
			// 	"Egg dropping refers to a class of problems in which it is important to find the correct response without exceeding a few number of certain failure states.\
			// 	\n \n Suppose you have 'n' eggs and you want to determine from which floors in a 'k'-floor building you can drop an egg such that is doesn't break. You are to determine the minimum number of attempts you need in order to find the critical floor in the worst case while using the best strategy."
			// }
			desc_v2={<div>Egg dropping refers to a class of problems in which it is important to find the correct response without exceeding a (low) number of certain failure states.
				<br/><br/>Suppose There are <i>n</i> eggs, and you want to determine from which floors in a <i>k</i>-floor building you can drop an egg such that is doesn't break. You are to determine the minimum number of attempts you need in order to find the critical floor in the worst case while using the best strategy.
				<br/><br/></div>}
			headerPreBullet={"Notes"}
			headerBullet={[
				"If the egg doesn't break at a certain floor, it will not break at any floor below.",
				"If the eggs break at a certain floor, it will break at any floor above.",
				"The egg may break at the first floor.",
				"The egg may not break at the last floor.",
			]}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"# of Eggs"}
			label2={"# of Floors"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={true}
			numberOnly2={true}
			txtButton={"Calculate"}
			style={1}
			//------
			width1={200}
		/>
	);
};

export default EggDropping;
